import * as Yup from 'yup';

const filesArrayBase = () =>
  Yup.array()
    .required('Required')
    .min(1, 'Required')
    .test('no-failed-uploads', 'Please remove all failed upload documents', (files) => {
      return files ? !files.some((file) => file.isError === true) : true;
    });

// Files-only validation schema for Clive mode
// Only validates that files exist and are valid - no form fields required
//
// There is deliberately no file-type check: Clive is told about every file, and one it cannot read
// comes back as a document saying so rather than being refused at the dropzone with no record that
// the user tried.
export const CLIVE_FILES_ONLY_VALIDATION = Yup.object().shape({
  files: filesArrayBase(),
});
